/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Preset_MonthInputs */

const vi_report_preset_month = /** @type {(inputs: Report_Preset_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tháng này`)
};

/**

* @param {Report_Preset_MonthInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_preset_month = /** @type {((inputs?: Report_Preset_MonthInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Preset_MonthInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_preset_month(inputs)
});